(() => {
  const icons = {
    mountain: "M 18 55 L36 33 L47 44 L62 24 L88 55 M30 55 L46 43 M56 55 L68 41",
    star: "M53 22 L61 43 L84 43 L65 56 L72 78 L53 64 L34 78 L41 56 L22 43 L45 43 Z",
    bolt: "M58 19 L32 55 H52 L45 83 L76 44 H56 Z",
  };

  const defaultMaterial = {
    id: "swatch-63",
    label: "Saddle Tan (Swatch 63)",
    bg: "#b8733e",
    ink: "#281711",
    texture: "",
  };

  const startingState = {
    customerName: "Fresh Catch Customer",
    sampleInfo: "Choose a hat, upload artwork, then position the patch.",
    hatLabel: "Richardson 112 - Black",
    hatBrand: "Richardson",
    hatModel: "112",
    hatColor: "Black",
    hatSrc: "",
    hatGallery: [],
    hatViewLabels: [],
    hatViewIndex: 0,
    patchX: 50,
    patchY: 43,
    patchSize: 24,
    patchText: "YOUR LOGO",
    patchSubtext: "CUSTOM PATCH",
    material: defaultMaterial.label,
    materialId: defaultMaterial.id,
    materialBg: defaultMaterial.bg,
    materialInk: defaultMaterial.ink,
    materialTexture: defaultMaterial.texture,
    patchTextColor: defaultMaterial.ink,
    patchBorderColor: defaultMaterial.ink,
    patchMode: "leather",
    shape: "rectangle",
    icon: "mountain",
    borderStyle: "none",
    patchDepth: 8,
    patchTiltY: 0,
    artScale: 100,
    logoDataUrl: "",
  };

  const revealNodes = () => {
    const nodes = Array.from(document.querySelectorAll("[data-reveal]"));
    if (!("IntersectionObserver" in window)) {
      nodes.forEach((node) => node.classList.add("is-visible"));
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) entry.target.classList.add("is-visible");
        });
      },
      { threshold: 0.12, rootMargin: "0px 0px -60px" },
    );
    nodes.forEach((node) => observer.observe(node));
  };

  const setupMenu = () => {
    const toggle = document.querySelector("[data-menu-toggle]");
    const nav = document.getElementById("PrimaryNavigation");
    if (!toggle || !nav) return;

    toggle.addEventListener("click", () => {
      const open = nav.classList.toggle("is-open");
      toggle.setAttribute("aria-expanded", String(open));
    });
  };

  const setupChoiceRows = () => {
    document.querySelectorAll("[data-choice-row]").forEach((row) => {
      row.addEventListener("click", (event) => {
        const button = event.target.closest("button");
        if (!button) return;
        row.querySelectorAll("button").forEach((item) => item.classList.remove("is-selected"));
        button.classList.add("is-selected");
      });
    });
  };

  const setupFaq = () => {
    document.querySelectorAll("[data-faq-toggle]").forEach((toggle) => {
      toggle.addEventListener("click", () => {
        const item = toggle.closest("[data-faq-item]");
        if (!item) return;
        item.parentElement.querySelectorAll("[data-faq-item]").forEach((other) => {
          if (other !== item) other.classList.remove("is-open");
        });
        item.classList.toggle("is-open");
      });
    });
  };

  const setupPortfolioFilters = () => {
    const filters = document.querySelector("[data-portfolio-filters]");
    const grid = document.querySelector("[data-portfolio-grid]");
    if (!filters || !grid) return;

    filters.addEventListener("click", (event) => {
      const button = event.target.closest("button[data-filter]");
      if (!button) return;
      const filter = button.dataset.filter;
      filters.querySelectorAll("button").forEach((item) => item.classList.remove("is-selected"));
      button.classList.add("is-selected");
      grid.querySelectorAll("[data-type]").forEach((item) => {
        item.classList.toggle("is-hidden", filter !== "All" && item.dataset.type !== filter);
      });
    });
  };

  const setupMockups = () => {
    const clamp = (value, min, max) => Math.min(Math.max(value, min), max);
    const uniqueSorted = (items) => Array.from(new Set(items.filter(Boolean))).sort((a, b) => a.localeCompare(b));
    const readMaterial = (button) => ({
      materialId: button?.dataset.material || defaultMaterial.id,
      material: button?.dataset.label || defaultMaterial.label,
      materialBg: button?.dataset.bg || defaultMaterial.bg,
      materialInk: button?.dataset.ink || defaultMaterial.ink,
      materialTexture: button?.dataset.texture || defaultMaterial.texture,
    });

    document.querySelectorAll("[data-mockup]").forEach((root) => {
      const state = { ...startingState };
      const fields = root.querySelectorAll(".js-mockup-field");
      const colorFields = root.querySelectorAll(".js-color-field");
      const stage = root.querySelector(".mockup-stage");
      const hatImage = root.querySelector(".js-hat-image");
      const hatViewGallery = root.querySelector(".js-hat-view-gallery");
      const patch = root.querySelector("[data-mockup-patch]");
      const iconNode = root.querySelector(".js-patch-icon");
      const patchText = root.querySelector(".js-patch-text");
      const patchSubtext = root.querySelector(".js-patch-subtext");
      const proofCustomer = root.querySelector(".js-proof-customer");
      const proofSample = root.querySelector(".js-proof-sample");
      const copyButton = root.querySelector(".js-copy-spec");
      const selectedHatLabel = root.querySelector(".js-selected-hat-label");
      const selectedViewLabel = root.querySelector(".js-selected-view-label");
      const selectedPatchLabel = root.querySelector(".js-selected-patch-label");
      const cameraButton = root.querySelector(".js-camera-preview");
      const cameraPanel = root.querySelector(".js-camera-panel");
      const cameraStage = root.querySelector(".js-camera-stage");
      const cameraVideo = root.querySelector(".js-camera-video");
      const cameraCaptureInput = root.querySelector(".js-camera-capture");
      const cameraCaptureImage = root.querySelector(".js-camera-capture-image");
      const cameraPatch = root.querySelector(".js-camera-patch");
      const cameraIconNode = root.querySelector(".js-camera-patch-icon");
      const cameraPatchText = root.querySelector(".js-camera-patch-text");
      const cameraPatchSubtext = root.querySelector(".js-camera-patch-subtext");
      const cameraStopButton = root.querySelector(".js-camera-stop");
      const cameraFreezeButton = root.querySelector(".js-camera-freeze");
      const cameraStatus = root.querySelector(".js-camera-status");
      let cameraStream = null;
      let cameraFrozen = false;
      let cameraCaptureUrl = "";
      const selectedHat = root.querySelector("[data-hat-src].is-selected") || root.querySelector("[data-hat-src]");
      const selectedMaterial = root.querySelector("[data-material].is-selected") || root.querySelector("[data-material]");
      const hatBrandSelect = root.querySelector(".js-hat-brand");
      const hatModelSelect = root.querySelector(".js-hat-model");
      const hatResultCount = root.querySelector(".js-hat-result-count");
      const hatButtonContainer = root.querySelector(".hat-buttons-catalog");
      let hatButtons = Array.from(root.querySelectorAll("[data-hat-src]"));
      const splitDataList = (value) => String(value || "").split("|").map((item) => item.trim()).filter(Boolean);
      const refreshHatButtonList = () => {
        hatButtons = Array.from(root.querySelectorAll("[data-hat-src]"));
      };
      const readHat = (button) => ({
        ...(() => {
          const gallery = splitDataList(button?.dataset.hatGallery);
          const fallbackSrc = button?.dataset.hatSrc || "";
          const hatGallery = gallery.length ? gallery : fallbackSrc ? [fallbackSrc] : [];
          const labels = splitDataList(button?.dataset.hatViewLabels);

          return {
            hatLabel: button?.dataset.hatLabel || startingState.hatLabel,
            hatBrand: button?.dataset.hatBrand || "",
            hatModel: button?.dataset.hatModel || "",
            hatColor: button?.dataset.hatColor || button?.dataset.hatLabel || "",
            hatSrc: hatGallery[0] || fallbackSrc,
            hatGallery,
            hatViewLabels: hatGallery.map((_, index) => labels[index] || (index === 0 ? "Front" : `View ${index + 1}`)),
            hatViewIndex: 0,
            patchX: Number(button?.dataset.hatX) || startingState.patchX,
            patchY: Number(button?.dataset.hatY) || startingState.patchY,
            patchSize: Number(button?.dataset.hatSize) || startingState.patchSize,
          };
        })(),
      });
      const setHatFromButton = (button) => {
        if (!button) return;
        Object.assign(state, readHat(button));
        hatButtons.forEach((item) => item.classList.remove("is-selected"));
        button.classList.add("is-selected");
      };

      root.querySelectorAll("[data-material]").forEach((button) => {
        const swatch = button.querySelector("i");
        if (swatch && button.dataset.texture) swatch.style.setProperty("--swatch-image", `url("${button.dataset.texture}")`);
      });

      const fillSelect = (select, values, fallbackLabel) => {
        if (!select) return;
        const current = select.value || "all";
        select.innerHTML = "";
        const all = document.createElement("option");
        all.value = "all";
        all.textContent = fallbackLabel;
        select.appendChild(all);
        values.forEach((value) => {
          const option = document.createElement("option");
          option.value = value;
          option.textContent = value;
          select.appendChild(option);
        });
        select.value = values.includes(current) ? current : "all";
      };

      const syncModelOptions = () => {
        const brand = hatBrandSelect?.value || "all";
        const models = uniqueSorted(
          hatButtons
            .filter((button) => brand === "all" || button.dataset.hatBrand === brand)
            .map((button) => button.dataset.hatModel),
        );
        fillSelect(hatModelSelect, models, "All models");
      };

      const applyHatFilters = () => {
        const brand = hatBrandSelect?.value || "all";
        const model = hatModelSelect?.value || "all";
        const visibleButtons = hatButtons.filter((button) => {
          const visible = (brand === "all" || button.dataset.hatBrand === brand) && (model === "all" || button.dataset.hatModel === model);
          button.hidden = !visible;
          return visible;
        });
        if (hatResultCount) {
          const count = visibleButtons.length;
          hatResultCount.textContent = `${count} color${count === 1 ? "" : "s"}`;
        }
        const active = root.querySelector("[data-hat-src].is-selected");
        if (active?.hidden && visibleButtons.length) {
          setHatFromButton(visibleButtons[0]);
          render();
        }
      };

      if (hatBrandSelect) fillSelect(hatBrandSelect, uniqueSorted(hatButtons.map((button) => button.dataset.hatBrand)), "All brands");
      syncModelOptions();
      if (selectedHat) setHatFromButton(selectedHat);
      if (selectedMaterial) {
        Object.assign(state, readMaterial(selectedMaterial));
        state.patchTextColor = state.materialInk || defaultMaterial.ink;
        state.patchBorderColor = state.materialInk || defaultMaterial.ink;
      }

      const renderHatViews = () => {
        if (!hatViewGallery) return;
        const gallery = state.hatGallery?.length ? state.hatGallery : state.hatSrc ? [state.hatSrc] : [];
        const labels = gallery.map((_, index) => state.hatViewLabels?.[index] || (index === 0 ? "Front" : `View ${index + 1}`));
        hatViewGallery.innerHTML = "";
        hatViewGallery.hidden = gallery.length <= 1;

        gallery.forEach((src, index) => {
          const button = document.createElement("button");
          button.type = "button";
          button.dataset.hatViewIndex = String(index);
          button.dataset.hatViewSrc = src;
          button.classList.toggle("is-selected", index === state.hatViewIndex);
          button.setAttribute("aria-label", `${labels[index]} view of ${state.hatLabel}`);
          button.style.setProperty("--hat-view-thumb", `url("${src}")`);
          button.innerHTML = `<i aria-hidden="true"></i><span>${labels[index]}</span>`;
          hatViewGallery.appendChild(button);
        });
      };

      const shapeClasses = ["patch-circle", "patch-shield", "patch-rectangle", "patch-oval", "patch-hex", "patch-arch"];
      const borderClasses = [
        "patch-border-stitch",
        "patch-border-single",
        "patch-border-double",
        "patch-border-inset",
        "patch-border-rope",
        "patch-border-scallop",
        "patch-border-western",
        "patch-border-burned",
        "patch-border-clean",
        "patch-border-none",
      ];

      const syncPatchSurface = (node) => {
        if (!node) return;
        node.classList.remove(...shapeClasses, ...borderClasses);
        node.classList.add(`patch-${state.shape}`);
        node.classList.add(`patch-border-${state.borderStyle}`);
        node.classList.toggle("is-logo-only", state.patchMode === "logo");
        node.classList.toggle("has-uploaded-art", Boolean(state.logoDataUrl));
        node.classList.toggle("has-material-texture", Boolean(state.materialTexture));
        node.style.setProperty("--patch-bg", state.materialBg || defaultMaterial.bg);
        node.style.setProperty("--patch-ink", state.materialInk || defaultMaterial.ink);
        node.style.setProperty("--patch-text-color", state.patchTextColor || state.materialInk || defaultMaterial.ink);
        node.style.setProperty("--patch-border-color", state.patchBorderColor || state.materialInk || defaultMaterial.ink);
        node.style.setProperty("--patch-texture", state.materialTexture ? `url("${state.materialTexture}")` : "none");
        node.style.setProperty("--patch-x", `${state.patchX}%`);
        node.style.setProperty("--patch-y", `${state.patchY}%`);
        node.style.setProperty("--patch-size", `${state.patchSize}%`);
        node.style.setProperty("--patch-depth", `${state.patchDepth}px`);
        node.style.setProperty("--patch-tilt-y", `${state.patchTiltY}deg`);
        node.style.setProperty("--art-scale", `${state.artScale / 100}`);
      };

      const renderPatchArtwork = (targetIcon, targetText, targetSubtext) => {
        const hasEngravingText = Boolean(state.patchText || state.patchSubtext);
        if (targetText) targetText.textContent = state.patchText ?? "";
        if (targetSubtext) targetSubtext.textContent = state.patchSubtext ?? "";
        if (targetIcon && state.logoDataUrl) {
          targetIcon.innerHTML = `<img src="${state.logoDataUrl}" alt="">`;
        } else if (targetIcon && icons[state.icon] && hasEngravingText) {
          targetIcon.innerHTML = `<svg viewBox="0 0 106 96" aria-hidden="true"><path d="${icons[state.icon]}"></path></svg>`;
        } else if (targetIcon) {
          targetIcon.innerHTML = "";
        }
      };

      const renderCameraPatch = () => {
        syncPatchSurface(cameraPatch);
        renderPatchArtwork(cameraIconNode, cameraPatchText, cameraPatchSubtext);
      };

      const render = () => {
        if (hatImage && state.hatSrc && hatImage.getAttribute("src") !== state.hatSrc) {
          hatImage.setAttribute("src", state.hatSrc);
        }
        if (hatImage) {
          const viewLabel = state.hatViewLabels?.[state.hatViewIndex] || "Front";
          hatImage.setAttribute("alt", `${state.hatLabel} ${viewLabel.toLowerCase()} view`);
        }
        if (stage) stage.classList.toggle("is-alt-hat-view", Number(state.hatViewIndex) > 0);
        if (patchText) patchText.textContent = state.patchText ?? "";
        if (patchSubtext) patchSubtext.textContent = state.patchSubtext ?? "";
        if (proofCustomer) proofCustomer.textContent = state.customerName || "Insert name here";
        if (proofSample) proofSample.textContent = state.sampleInfo || "Insert info here";
        if (patch) {
          patch.classList.remove("patch-circle", "patch-shield", "patch-rectangle", "patch-oval", "patch-hex", "patch-arch");
          patch.classList.remove(
            "patch-border-stitch",
            "patch-border-single",
            "patch-border-double",
            "patch-border-inset",
            "patch-border-rope",
            "patch-border-scallop",
            "patch-border-western",
            "patch-border-burned",
            "patch-border-clean",
            "patch-border-none",
          );
          patch.classList.add(`patch-${state.shape}`);
          patch.classList.add(`patch-border-${state.borderStyle}`);
          patch.classList.toggle("is-logo-only", state.patchMode === "logo");
          patch.classList.toggle("has-uploaded-art", Boolean(state.logoDataUrl));
          patch.classList.toggle("has-material-texture", Boolean(state.materialTexture));
          patch.style.setProperty("--patch-bg", state.materialBg || defaultMaterial.bg);
          patch.style.setProperty("--patch-ink", state.materialInk || defaultMaterial.ink);
          patch.style.setProperty("--patch-text-color", state.patchTextColor || state.materialInk || defaultMaterial.ink);
          patch.style.setProperty("--patch-border-color", state.patchBorderColor || state.materialInk || defaultMaterial.ink);
          patch.style.setProperty("--patch-texture", state.materialTexture ? `url("${state.materialTexture}")` : "none");
          patch.style.setProperty("--patch-x", `${state.patchX}%`);
          patch.style.setProperty("--patch-y", `${state.patchY}%`);
          patch.style.setProperty("--patch-size", `${state.patchSize}%`);
          patch.style.setProperty("--patch-depth", `${state.patchDepth}px`);
          patch.style.setProperty("--patch-tilt-y", `${state.patchTiltY}deg`);
          patch.style.setProperty("--art-scale", `${state.artScale / 100}`);
        }
        const hasEngravingText = Boolean(state.patchText || state.patchSubtext);
        if (iconNode && state.logoDataUrl) {
          iconNode.innerHTML = `<img src="${state.logoDataUrl}" alt="">`;
        } else if (iconNode && icons[state.icon] && hasEngravingText) {
          iconNode.innerHTML = `<svg viewBox="0 0 106 96" aria-hidden="true"><path d="${icons[state.icon]}"></path></svg>`;
        } else if (iconNode) {
          iconNode.innerHTML = "";
        }
        renderCameraPatch();
        if (selectedHatLabel) selectedHatLabel.textContent = state.hatLabel;
        if (selectedViewLabel) selectedViewLabel.textContent = `${state.hatViewLabels?.[state.hatViewIndex] || "Front"} view`;
        if (selectedPatchLabel) {
          selectedPatchLabel.textContent =
            state.patchMode === "logo"
              ? state.logoDataUrl
                ? "Full-color logo only"
                : "Logo-only mode - upload artwork"
              : `${state.material} ${state.shape} patch`;
        }
        hatButtons.forEach((button) => {
          button.classList.toggle("is-selected", button.dataset.hatLabel === state.hatLabel);
        });
        renderHatViews();
        root.querySelectorAll(".js-patch-range").forEach((range) => {
          const axis = range.dataset.axis;
          if (axis === "x") range.value = state.patchX;
          if (axis === "y") range.value = state.patchY;
          if (axis === "size") range.value = state.patchSize;
          if (axis === "depth") range.value = state.patchDepth;
          if (axis === "tiltY") range.value = state.patchTiltY;
          if (axis === "artScale") range.value = state.artScale;
        });
        root.querySelectorAll(".js-range-value").forEach((output) => {
          const key = output.dataset.rangeValue;
          if (key === "size") output.textContent = `${Number(state.patchSize).toFixed(0)}%`;
          if (key === "artScale") output.textContent = `${Number(state.artScale).toFixed(0)}%`;
        });
        colorFields.forEach((field) => {
          const key = field.dataset.colorField;
          if (key && state[key]) field.value = state[key];
        });
      };

      const makeCatalogAssetUrl = (assetBase, filename) => {
        if (!filename) return "";
        const url = `${assetBase || ""}${filename}`;
        if (url.startsWith("//")) return `${window.location.protocol}${url}`;
        return url;
      };

      const createExternalHatButton = (entry, assetBase) => {
        const views = Array.isArray(entry.views) ? entry.views.filter((view) => view?.filename) : [];
        if (!views.length) return null;

        const gallery = views.map((view) => makeCatalogAssetUrl(assetBase, view.filename));
        const labels = views.map((view, index) => view.label || (index === 0 ? "Front" : `View ${index + 1}`));
        const brand = entry.brand || "Hat";
        const model = entry.model || "Hat";
        const color = entry.color || "Color";
        const brandModel = [brand, model].filter(Boolean).join(" ");
        const src = gallery[0];
        const button = document.createElement("button");
        const swatch = document.createElement("i");
        const label = document.createElement("span");
        const strong = document.createElement("strong");
        const small = document.createElement("small");

        button.type = "button";
        button.dataset.hatLabel = `${brandModel} - ${color}`;
        button.dataset.hatBrand = brand;
        button.dataset.hatModel = model;
        button.dataset.hatColor = color;
        button.dataset.hatSrc = src;
        button.dataset.hatGallery = gallery.join("|");
        button.dataset.hatViewLabels = labels.join("|");
        button.dataset.hatX = entry.hatX || "50";
        button.dataset.hatY = entry.hatY || "43";
        button.dataset.hatSize = entry.hatSize || "23";
        swatch.style.setProperty("--hat-thumb", `url("${src}")`);
        strong.textContent = color;
        small.textContent = brandModel;
        label.append(strong, small);
        button.append(swatch, label);
        return button;
      };

      const loadExternalHatCatalogs = async () => {
        const markers = Array.from(root.querySelectorAll("[data-external-hat-catalog]")).filter((marker) => marker.dataset.catalogLoaded !== "true");
        if (!markers.length || !hatButtonContainer) return;

        await Promise.all(
          markers.map(async (marker) => {
            try {
              const response = await fetch(marker.dataset.catalogUrl, { cache: "force-cache" });
              if (!response.ok) throw new Error(`Catalog request failed: ${response.status}`);
              const catalog = await response.json();
              const assetBase = marker.dataset.assetBase || "";
              (catalog.entries || []).forEach((entry) => {
                const button = createExternalHatButton(entry, assetBase);
                if (button) hatButtonContainer.appendChild(button);
              });
              marker.dataset.catalogLoaded = "true";
            } catch (error) {
              console.warn("Hat catalog could not be loaded", error);
            }
          }),
        );

        refreshHatButtonList();
        if (!root.querySelector("[data-hat-src].is-selected") && hatButtons.length) setHatFromButton(hatButtons[0]);
        if (hatBrandSelect) fillSelect(hatBrandSelect, uniqueSorted(hatButtons.map((button) => button.dataset.hatBrand)), "All brands");
        syncModelOptions();
        applyHatFilters();
        render();
      };

      hatViewGallery?.addEventListener("click", (event) => {
        const button = event.target.closest("button[data-hat-view-index]");
        if (!button || !hatViewGallery.contains(button)) return;
        const nextIndex = Number(button.dataset.hatViewIndex);
        if (!Number.isFinite(nextIndex) || !state.hatGallery[nextIndex]) return;
        state.hatViewIndex = nextIndex;
        state.hatSrc = state.hatGallery[nextIndex];
        render();
      });

      fields.forEach((field) => {
        field.addEventListener("input", () => {
          const key = field.dataset.field;
          state[key] = key && key.toLowerCase().includes("text") ? field.value.toUpperCase() : field.value;
          if (key && key.toLowerCase().includes("text")) field.value = state[key];
          render();
        });
      });

      root.querySelectorAll("[data-material]").forEach((button) => {
        button.addEventListener("click", () => {
          Object.assign(state, readMaterial(button));
          state.patchTextColor = state.materialInk || defaultMaterial.ink;
          state.patchBorderColor = state.materialInk || defaultMaterial.ink;
          root.querySelectorAll("[data-material]").forEach((item) => item.classList.remove("is-selected"));
          button.classList.add("is-selected");
          render();
        });
      });

      colorFields.forEach((field) => {
        field.addEventListener("input", () => {
          const key = field.dataset.colorField;
          if (key) state[key] = field.value;
          render();
        });
      });

      root.querySelectorAll("[data-color-preset]").forEach((button) => {
        button.addEventListener("click", () => {
          const key = button.dataset.colorPreset;
          const value = button.dataset.colorValue;
          if (key && value) state[key] = value;
          render();
        });
      });

      hatButtonContainer?.addEventListener("click", (event) => {
        const button = event.target.closest("[data-hat-src]");
        if (!button || !hatButtonContainer.contains(button)) return;
        setHatFromButton(button);
        render();
      });

      hatBrandSelect?.addEventListener("change", () => {
        syncModelOptions();
        applyHatFilters();
      });

      hatModelSelect?.addEventListener("change", applyHatFilters);

      root.querySelectorAll(".js-patch-range").forEach((range) => {
        range.addEventListener("input", () => {
          const value = Number(range.value);
          if (range.dataset.axis === "x") state.patchX = clamp(value, 26, 74);
          if (range.dataset.axis === "y") state.patchY = clamp(value, 28, 62);
          if (range.dataset.axis === "size") state.patchSize = clamp(value, 14, 40);
          if (range.dataset.axis === "depth") state.patchDepth = clamp(value, 2, 14);
          if (range.dataset.axis === "tiltY") state.patchTiltY = clamp(value, -12, 12);
          if (range.dataset.axis === "artScale") state.artScale = clamp(value, 45, 180);
          render();
        });
      });

      root.querySelector(".js-center-patch")?.addEventListener("click", () => {
        const activeHat = root.querySelector("[data-hat-src].is-selected") || selectedHat;
        state.patchX = Number(activeHat?.dataset.hatX) || startingState.patchX;
        state.patchY = Number(activeHat?.dataset.hatY) || startingState.patchY;
        state.patchSize = Number(activeHat?.dataset.hatSize) || startingState.patchSize;
        render();
      });

      if (stage && patch) {
        const updatePatchPlacement = (event) => {
          const rect = stage.getBoundingClientRect();
          if (!rect.width || !rect.height) return;
          state.patchX = clamp(((event.clientX - rect.left) / rect.width) * 100, 26, 74);
          state.patchY = clamp(((event.clientY - rect.top) / rect.height) * 100, 28, 62);
          render();
        };

        let isDraggingPatch = false;

        const stopPatchDrag = () => {
          isDraggingPatch = false;
          patch.classList.remove("is-dragging");
        };

        const movePatch = (event) => {
          if (!isDraggingPatch) return;
          event.preventDefault?.();
          updatePatchPlacement(event);
        };

        const startPatchDrag = (event) => {
          if (event.button != null && event.button !== 0) return;
          event.preventDefault?.();
          isDraggingPatch = true;
          patch.classList.add("is-dragging");
          if (event.pointerId != null) patch.setPointerCapture?.(event.pointerId);
          updatePatchPlacement(event);
        };

        patch.addEventListener("pointerdown", startPatchDrag);
        patch.addEventListener("pointermove", movePatch);
        window.addEventListener("pointermove", movePatch);
        patch.addEventListener("mousedown", startPatchDrag);
        window.addEventListener("mousemove", movePatch);

        ["pointerup", "pointercancel", "lostpointercapture", "mouseup", "blur"].forEach((type) => {
          patch.addEventListener(type, stopPatchDrag);
          window.addEventListener(type, stopPatchDrag);
        });
      }

      const setCameraStatus = (message) => {
        if (cameraStatus) cameraStatus.textContent = message;
      };

      const setCameraFreezeLabel = () => {
        if (cameraFreezeButton) cameraFreezeButton.textContent = cameraFrozen ? "Resume camera" : "Freeze view";
      };

      const resetCapturedCameraImage = () => {
        if (cameraCaptureUrl) URL.revokeObjectURL(cameraCaptureUrl);
        cameraCaptureUrl = "";
        if (cameraCaptureImage) {
          cameraCaptureImage.hidden = true;
          cameraCaptureImage.removeAttribute("src");
        }
        if (cameraCaptureInput) cameraCaptureInput.value = "";
      };

      const stopCamera = () => {
        if (cameraStream) {
          cameraStream.getTracks().forEach((track) => track.stop());
          cameraStream = null;
        }
        resetCapturedCameraImage();
        if (cameraVideo) cameraVideo.srcObject = null;
        cameraFrozen = false;
        setCameraFreezeLabel();
        if (cameraFreezeButton) cameraFreezeButton.disabled = false;
        if (cameraPanel) {
          cameraPanel.hidden = true;
          cameraPanel.classList.remove("is-live", "is-error", "is-captured");
        }
        cameraButton?.classList.remove("is-selected");
        setCameraStatus("Line up your hat and drag the patch into place.");
      };

      const startCamera = async () => {
        if (!cameraPanel || !cameraVideo) return;
        cameraPanel.hidden = false;
        resetCapturedCameraImage();
        cameraPanel.classList.remove("is-error", "is-captured");
        cameraButton?.classList.add("is-selected");
        if (cameraFreezeButton) cameraFreezeButton.disabled = false;
        renderCameraPatch();

        if (!navigator.mediaDevices?.getUserMedia) {
          cameraPanel.classList.add("is-error");
          setCameraStatus("Camera preview is unavailable in this browser.");
          return;
        }

        try {
          if (!cameraStream) {
            cameraStream = await navigator.mediaDevices.getUserMedia({
              audio: false,
              video: {
                facingMode: { ideal: "environment" },
                width: { ideal: 1280 },
                height: { ideal: 960 },
              },
            });
          }
          cameraVideo.srcObject = cameraStream;
          cameraPanel.classList.add("is-live");
          cameraFrozen = false;
          setCameraFreezeLabel();
          setCameraStatus("Camera preview active. Drag the patch into place.");
          await cameraVideo.play().catch(() => {});
        } catch (error) {
          if (cameraStream) {
            cameraStream.getTracks().forEach((track) => track.stop());
            cameraStream = null;
          }
          cameraVideo.srcObject = null;
          cameraPanel.classList.remove("is-live");
          cameraPanel.classList.add("is-error");
          cameraFrozen = false;
          setCameraFreezeLabel();
          setCameraStatus("Camera permission was blocked or unavailable on this device.");
          console.warn("Hat camera preview unavailable", error);
        }
      };

      const useCapturedCameraImage = (file) => {
        if (!file || !cameraPanel || !cameraCaptureImage) return;
        if (cameraStream) {
          cameraStream.getTracks().forEach((track) => track.stop());
          cameraStream = null;
        }
        if (cameraVideo) {
          cameraVideo.pause();
          cameraVideo.srcObject = null;
        }
        resetCapturedCameraImage();
        cameraCaptureUrl = URL.createObjectURL(file);
        cameraCaptureImage.src = cameraCaptureUrl;
        cameraCaptureImage.hidden = false;
        cameraPanel.hidden = false;
        cameraPanel.classList.remove("is-live", "is-error");
        cameraPanel.classList.add("is-captured");
        cameraButton?.classList.add("is-selected");
        cameraFrozen = false;
        setCameraFreezeLabel();
        if (cameraFreezeButton) cameraFreezeButton.disabled = true;
        renderCameraPatch();
        setCameraStatus("Photo loaded. Drag the patch into place.");
      };

      const shouldUseCameraCaptureInput = () => {
        if (!cameraCaptureInput) return false;
        const coarsePointer = window.matchMedia?.("(pointer: coarse)")?.matches;
        const mobileUserAgent = /Android|iPhone|iPad|iPod|Mobile/i.test(navigator.userAgent);
        return Boolean(coarsePointer || mobileUserAgent);
      };

      if (cameraStage && cameraPatch) {
        const updateCameraPatchPlacement = (event) => {
          const rect = cameraStage.getBoundingClientRect();
          if (!rect.width || !rect.height) return;
          state.patchX = clamp(((event.clientX - rect.left) / rect.width) * 100, 26, 74);
          state.patchY = clamp(((event.clientY - rect.top) / rect.height) * 100, 28, 62);
          render();
        };

        let isDraggingCameraPatch = false;

        const stopCameraPatchDrag = () => {
          isDraggingCameraPatch = false;
          cameraPatch.classList.remove("is-dragging");
        };

        const moveCameraPatch = (event) => {
          if (!isDraggingCameraPatch) return;
          event.preventDefault?.();
          updateCameraPatchPlacement(event);
        };

        const startCameraPatchDrag = (event) => {
          if (event.button != null && event.button !== 0) return;
          event.preventDefault?.();
          isDraggingCameraPatch = true;
          cameraPatch.classList.add("is-dragging");
          if (event.pointerId != null) cameraPatch.setPointerCapture?.(event.pointerId);
          updateCameraPatchPlacement(event);
        };

        cameraPatch.addEventListener("pointerdown", startCameraPatchDrag);
        cameraPatch.addEventListener("pointermove", moveCameraPatch);
        window.addEventListener("pointermove", moveCameraPatch);
        cameraPatch.addEventListener("mousedown", startCameraPatchDrag);
        window.addEventListener("mousemove", moveCameraPatch);

        ["pointerup", "pointercancel", "lostpointercapture", "mouseup", "blur"].forEach((type) => {
          cameraPatch.addEventListener(type, stopCameraPatchDrag);
          window.addEventListener(type, stopCameraPatchDrag);
        });
      }

      cameraButton?.addEventListener("click", () => {
        if (cameraStream || cameraCaptureUrl) {
          stopCamera();
        } else if (shouldUseCameraCaptureInput()) {
          cameraCaptureInput.click();
        } else {
          startCamera();
        }
      });

      cameraCaptureInput?.addEventListener("change", () => {
        const file = cameraCaptureInput.files?.[0];
        if (file) useCapturedCameraImage(file);
      });

      cameraStopButton?.addEventListener("click", stopCamera);
      cameraFreezeButton?.addEventListener("click", async () => {
        if (!cameraVideo || !cameraStream) return;
        cameraFrozen = !cameraFrozen;
        if (cameraFrozen) {
          cameraVideo.pause();
          setCameraStatus("Preview frozen. Drag the patch into place.");
        } else {
          await cameraVideo.play().catch(() => {});
          setCameraStatus("Camera preview active. Drag the patch into place.");
        }
        setCameraFreezeLabel();
      });
      window.addEventListener("pagehide", stopCamera);

      root.querySelectorAll("[data-shape]").forEach((button) => {
        button.addEventListener("click", () => {
          state.shape = button.dataset.shape || "rectangle";
          root.querySelectorAll("[data-shape]").forEach((item) => item.classList.remove("is-selected"));
          button.classList.add("is-selected");
          render();
        });
      });

      root.querySelectorAll("[data-border-style]").forEach((button) => {
        button.addEventListener("click", () => {
          state.borderStyle = button.dataset.borderStyle || "none";
          root.querySelectorAll("[data-border-style]").forEach((item) => item.classList.remove("is-selected"));
          button.classList.add("is-selected");
          render();
        });
      });

      root.querySelectorAll("[data-patch-mode]").forEach((button) => {
        button.addEventListener("click", () => {
          state.patchMode = button.dataset.patchMode || "leather";
          root.querySelectorAll("[data-patch-mode]").forEach((item) => item.classList.remove("is-selected"));
          button.classList.add("is-selected");
          render();
        });
      });

      root.querySelectorAll("[data-icon]").forEach((button) => {
        button.addEventListener("click", () => {
          state.icon = button.dataset.icon || "mountain";
          state.logoDataUrl = "";
          root.querySelectorAll("[data-icon]").forEach((item) => item.classList.remove("is-selected"));
          button.classList.add("is-selected");
          render();
        });
      });

      const upload = root.querySelector(".js-logo-upload");
      if (upload && iconNode) {
        upload.addEventListener("change", () => {
          const file = upload.files && upload.files[0];
          if (!file) return;
          const reader = new FileReader();
          reader.onload = () => {
            state.logoDataUrl = String(reader.result || "");
            render();
          };
          reader.readAsDataURL(file);
        });
      }

      root.querySelector(".js-clear-upload")?.addEventListener("click", () => {
        state.logoDataUrl = "";
        if (upload) upload.value = "";
        render();
      });

      if (copyButton) {
        copyButton.addEventListener("click", async () => {
          const engravingText = [state.patchText, state.patchSubtext].filter(Boolean).join(" / ") || "(blank)";
          const specText = [
            `Customer: ${state.customerName}`,
            `Sample: ${state.sampleInfo}`,
            `Hat: ${state.hatBrand} ${state.hatModel} - ${state.hatColor}`,
            `Hat view: ${state.hatViewLabels?.[state.hatViewIndex] || "Front"}`,
            `Patch mode: ${state.patchMode === "logo" ? "Full-color logo only" : "Leather patch"}`,
            `Patch: ${state.patchMode === "logo" ? "Uploaded logo only" : `${state.material} ${state.shape}`}`,
            `Patch edge: ${state.patchMode === "logo" ? "none" : state.borderStyle}`,
            `Engraving: ${engravingText}`,
            `Text color: ${state.patchTextColor}`,
            `Border color: ${state.patchBorderColor}`,
            `Placement: X ${state.patchX.toFixed(1)}%, Y ${state.patchY.toFixed(1)}%, Size ${state.patchSize.toFixed(1)}%`,
            `3D: Depth ${state.patchDepth}px, Tilt ${state.patchTiltY}deg, Logo scale ${state.artScale}%`,
          ].join("\n");

          try {
            await navigator.clipboard.writeText(specText);
            copyButton.querySelector("span").textContent = "Specs Copied";
            window.setTimeout(() => {
              copyButton.querySelector("span").textContent = "Copy Hat Patch Specs";
            }, 1800);
          } catch {
            copyButton.querySelector("span").textContent = "Copy unavailable";
          }
        });
      }

      const reset = root.querySelector(".js-reset-mockup");
      if (reset) {
        reset.addEventListener("click", () => {
          Object.assign(state, startingState);
          if (selectedHat) {
            Object.assign(state, readHat(selectedHat));
          }
          fields.forEach((field) => {
            field.value = state[field.dataset.field] || "";
          });
          colorFields.forEach((field) => {
            field.value = state[field.dataset.colorField] || defaultMaterial.ink;
          });
          root.querySelectorAll("[data-material], [data-shape], [data-icon], [data-hat-src], [data-patch-mode]").forEach((item) => item.classList.remove("is-selected"));
          root.querySelectorAll("[data-border-style]").forEach((item) => item.classList.remove("is-selected"));
          selectedHat?.classList.add("is-selected");
          if (hatBrandSelect) hatBrandSelect.value = "all";
          syncModelOptions();
          if (hatModelSelect) hatModelSelect.value = "all";
          applyHatFilters();
          if (selectedMaterial) {
            Object.assign(state, readMaterial(selectedMaterial));
            state.patchTextColor = state.materialInk || defaultMaterial.ink;
            state.patchBorderColor = state.materialInk || defaultMaterial.ink;
            selectedMaterial.classList.add("is-selected");
          }
          root.querySelector('[data-patch-mode="leather"]')?.classList.add("is-selected");
          root.querySelector('[data-shape="rectangle"]')?.classList.add("is-selected");
          root.querySelector('[data-icon="mountain"]')?.classList.add("is-selected");
          root.querySelector('[data-border-style="none"]')?.classList.add("is-selected");
          if (upload) upload.value = "";
          render();
        });
      }

      loadExternalHatCatalogs();
      applyHatFilters();
      render();
    });
  };

  const initAdvancedMockup = () => {
    revealNodes();
    setupMenu();
    setupChoiceRows();
    setupFaq();
    setupPortfolioFilters();
    setupMockups();
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAdvancedMockup);
  } else {
    initAdvancedMockup();
  }
})();
